/* eslint class-methods-use-this: 0 */
import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Cookie from 'common/services/util/-RFC.Cookie';

const _serviceDependencies = ['$rootScope', '$scope', 'Util', 'Auth', 'GdprActionsRestService'];

let _$rootScope;
let _$scope;
let _Util;
let _Auth;
let _User;
let _GdprActionsRestService;
let _formIsValid = null;
let _formPasswordValue;

/**
 * @ngdoc service
 * @name controllers.DeleteAccountConfirmation
 *
 * @description
 * Crop Image controller
 */
class DeleteAccountConfirmation {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} GdprActionsRestService
     */

    constructor($rootScope, $scope, Util, Auth, GdprActionsRestService) {

        _Util = Util;
        _Auth = Auth;
        _GdprActionsRestService = GdprActionsRestService;
        _User = MeRepository.getMyUser();
        _$scope = $scope;
        _$rootScope = $rootScope;

        // functions
        _$scope.closeModal = this.closeModal;
        _$scope.setEmail = this.setEmail;
        _$scope.confirmDeleteAccount = this.confirmDeleteAccount;
        _$scope.continueToPassword = this.continueToPassword;

        // variables

        _$scope.authError = false;
        _$scope.loading = false;
        _$scope.loadingConfirm = false;
        _$scope.failedLogins = 0;
        _$scope.brandName = CWCONFIG.partnerConfig.name;
        _$scope.passwordStep = false;
        _$scope.submitted = false;

        const logintype = Cookie.get(CWCONFIG.cookie.loginType);
        _$scope.socialLogin = (logintype === 'gg_auth' || logintype === 'fb_auth' || logintype === 'apl_auth');

        _$scope.$on('$destroy', () => {

            delete $rootScope.passwordConfirmationFor;

        });

    }

    closeModal() {

        _Util.closeModal();

    }

    continueToPassword() {

        _$scope.passwordStep = true;

    }

    confirmDeleteAccount() {

        if (this.verifyIdentityForm) {

            _formIsValid = this.verifyIdentityForm.$valid;

            _formPasswordValue = this.verifyIdentityForm.password.$viewValue;

        }

        if (_formIsValid || _$scope.socialLogin) {

            _$scope.loadingConfirm = true;

            const payload = {
                data: {
                    attributes: {
                        action_type: 'gdpr_delete_account',
                    },
                },
                meta: {
                    delete_source: 'dashboard',
                    password: _formPasswordValue,
                },
            };

            _GdprActionsRestService.create(payload).then(() => {

                Mixpanel.send('ConnectWeb Delete Account Confirm');

                localStorage.removeItem('lastLogin');
                _Auth.logOut();

            }).then(null, (error) => {

                let errorReason;
                _$scope.loadingConfirm = false;

                if (_Util.deepFind(error, 'data.error')) {

                    errorReason = error.data.code;

                } else if (_Util.deepFind(error, 'data.errors')) {

                    errorReason = error.data.errors[0].code;

                }

                if (errorReason === '1808') {

                    this.closeModal();
                    Alert.error('cw.delete_account.already_requested_error');

                } else if (error.data.error === 'invalid_credentials') {

                    this.closeModal();
                    Alert.error('cw.auth.login.error.email_password');

                } else {

                    this.closeModal();
                    Alert.error('cw.delete_account.error');

                }

            });

        } else {

            _$scope.submitted = true;

            _Util.triggerAnimation('.error', 'animated shake');

        }

    }

    setEmail() {

        _$rootScope.forgotEmail = _User.attributes.email;

    }

}

_serviceDependencies.push(DeleteAccountConfirmation);

angular.module('controllers')
    .controller('DeleteAccountConfirmation', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/controllers/modals/my-account/delete-account-confirmation/delete-account-confirmation.js